import styled from "styled-components";
import { ElementGroup, Title } from "styles/components";
import { PopupType } from "../../PopupType";
import { useAbsPopupButton, usePopupData } from "commons/popup/store/absPopupHook";
import Button from "components/ui/Button";
import { ButtonIcon, ButtonType, RadioType } from "components/ComponentsType";
import AbsPopup from "commons/popup/display/AbsPopup";
import { ButtonState } from "commons/popup/store/absPopupVo";
import { UiSelectBox } from "components/ui/SelectBox";
import { NowMonthSelectBox, NowYearSelectBox } from "pages/profit/Profit";
import { useDataDownload } from "./DataDownHook";

const Header = styled.div`
  padding: 20px 20px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  h3 {
    font-size: 1.3rem;
    font-weight: 600;
    margin: 0;
  }
  button {
    position: absolute;
    right: 10px;
  }
`;

const PopupContainer = styled.div`
  width: 100%;
  padding: 0 4px;
  position: relative;
  > p {
    color: #555858;
  }
`;

const SelectBoxWrap = styled.div`
  display: flex;
  margin: 10px 0;
  div {
    margin-right: 8px;
  }
`;

const FooterStyle = styled(ElementGroup.Row)`
  padding: 0 20px 14px 20px;
  button {
    width: 100px;
    background-color: #2c3030;
    font-size: 1rem;
  }
`;

export function CalCompanyDataDownPopupFooter() {
  const { download } = useDataDownload();

  return (
    <FooterStyle flexContent="end">
      <Button text="다운받기" btnSize={"sm"} radius={8} onClick={() => download()} />
    </FooterStyle>
  );
}

function PopupHeader() {
  const { close } = useAbsPopupButton(PopupType.CAL_COMPANY_DETAIL_POPUP);

  return (
    <Header>
      <Title weight="medium">{"업체별 상세 데이터"}</Title>
      <Button
        title="닫기"
        thin
        iconName={ButtonIcon.CLOSED}
        iconPosition="center"
        btnType="ghost"
        color={"dark"}
        onClick={close.bind(null, ButtonState.NO)}
      />
    </Header>
  );
}

export default function CalculateCompanyDataDownPopup(): JSX.Element {
  return (
    <AbsPopup type={PopupType.CAL_COMPANY_DETAIL_POPUP} borderShape={8} header={<PopupHeader />}>
      <PopupContainer>
        <p>데이터가 필요한 월을 선택해주세요.</p>
        <SelectBoxWrap>
          <UiSelectBox
            id={"calculate_company_popup_data_year"}
            data={NowYearSelectBox().yearData}
            selectId="value"
            selectType="id"
            size="xmd"
            displayType="new"
            init={String(NowYearSelectBox().year)}
          />
          <UiSelectBox
            id={"calculate_company_popup_data_month"}
            data={NowMonthSelectBox().month_list}
            selectId="value"
            selectType="id"
            size="md"
            displayType="new"
            init={String(NowMonthSelectBox().now_month)}
          />
        </SelectBoxWrap>
      </PopupContainer>
    </AbsPopup>
  );
}
